
import React, { Component } from 'react';

export default (BannerComponent, props, slotComponent) =>
  class MarketingBanner extends Component {
    state = {
      showBanner: false,
      visible: false,
      hiding: false
    };

    componentDidMount () {
      this.setState({ showBanner: true, hiding: false });
      setTimeout(() => this.setState({ visible: true }), 100);
    }

    handleTransitionEnd = () => {
      this.setState({ showBanner: false });
    };

    handleBannerClose = () => {
      this.setState({ hiding: true, visible: false });
    };

    render () {
      const { showBanner, hiding, visible } = this.state;
      return (
        showBanner
          ? <BannerComponent
            hiding={hiding}
            visible={visible}
            handleTransitionEnd={this.handleTransitionEnd}
            handleBannerClose={this.handleBannerClose}
            {...props} />
          : slotComponent
      );
    }
  };
